const PageHeaderDirective = function () {
    return {
        restrict: 'E',
        transclude: true,
        replace: true,
        template: '<h4 class="light green-text"><ng-transclude></ng-transclude></h4>'
    }
};

export { PageHeaderDirective };